import './index.less';

/**
 * Toast组件
 */
const Toast = class {
  constructor() {
    this.elId = 'hobbit_toast';
    this.timeouter = null;
  }

  el() {
    let el = document.getElementById(this.elId);
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('id', this.elId);
      const elMsg = document.createElement('div');
      elMsg.className = 'message';
      el.appendChild(elMsg);
      document.body.appendChild(el);
    }
    return el;
  }

  show(message = '', duration = 3500, type = 'info') {
    const el = this.el();
    const elMsg = el.children[0];
    el.className = `show ${type}`;
    elMsg.innerHTML = message;
    if (this.timeouter) {
      window.clearTimeout(this.timeouter);
    }
    this.timeouter = window.setTimeout(() => {
      this.hide();
    }, duration);
  }

  hide() {
    window.clearTimeout(this.timeouter);
    this.el().className = '';
  }

  success(message, duration) {
    this.show(message, duration, 'success');
  }

  warn(message, duration) {
    this.show(message, duration, 'warn');
  }

  error(message, duration) {
    this.show(message, duration, 'error');
  }

  info(message, duration) {
    this.show(message, duration, 'info');
  }
};

export default new Toast();
